import React, { useState } from 'react';

const TagsInput = ({ event, setEvent }) => {
  const [tags, setTags] = useState(event.event_tags ? event.event_tags : []);

  const removeTags = (indexToRemove) => {
    const filteredTags = tags.filter((_, index) => index !== indexToRemove);
    setTags(filteredTags);
    setEvent({ ...event, event_tags: filteredTags });
  };

  const isDuplicatedTag = (newTag) => {
    const existingTags = tags.filter((tag) => tag === newTag);
    return existingTags && existingTags.length > 0;
  };

  const addTags = (e) => {
    if (e.target.value !== '' && !isDuplicatedTag(e.target.value)) {
      let newTag = e.target.value;
      if (newTag.startsWith('#')) {
        newTag = newTag.slice(1);
      }
      const newTags = [...tags, newTag];
      setTags(newTags);
      setEvent({ ...event, event_tags: newTags });
      e.target.value = '';
    }
  };

  return (
    <div className="tags-input">
      <ul id="tags">
        {tags.map((tag, index) => (
          <li key={index} className="tag">
            <span className="tag-title">{tag}</span>
            <span className="tag-close-icon" onClick={() => removeTags(index)}>
              ×
            </span>
          </li>
        ))}
      </ul>
      {tags && tags.length < 20 && (
        <input
          type="text"
          onKeyUp={(e) => e.key === 'Enter' && addTags(e)}
          onBlur={(e) => addTags(e)}
          placeholder="入力してください。"
        />
      )}
    </div>
  );
};

export default TagsInput;
